unit AcademyEditPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  EditBaseForm,
  Data.DB,
  WEBLib.DB,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Vcl.Controls,
  WEBLib.DBCtrls,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  WEBLib.WebCtrls,
  SMX.Auth.Shared;

type
  TAcademyEditForm = class(TBaseEditForm)
    RecordId: TDBLabel;
    AcademyName: TDBEdit;
    Telephone: TDBEdit;
    Email: TDBEdit;
  private
    { Private declarations }

  protected
    function GetRequiredEditLevel: string; override;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  AcademyEditForm: TAcademyEditForm;

implementation

{$R *.dfm}

uses
  App.Shared,
  App.Web.Utils;

function TAcademyEditForm.GetRequiredEditLevel: string;
begin
  Result := GetStandardEditLevel;

end;


procedure TAcademyEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  RecordId := TDBLabel.Create('record-id');
  AcademyName := TDBEdit.Create('academy-name');
  Telephone := TDBEdit.Create('telephone');
  Email := TDBEdit.Create('email');

  RecordId.BeforeLoadDFMValues;
  AcademyName.BeforeLoadDFMValues;
  Telephone.BeforeLoadDFMValues;
  Email.BeforeLoadDFMValues;
  try
    Name := 'AcademyEditForm';
    RecordId.SetParentComponent(Self);
    RecordId.Name := 'RecordId';
    RecordId.Left := 40;
    RecordId.Top := 72;
    RecordId.Width := 47;
    RecordId.Height := 15;
    RecordId.Caption := 'RecordId';
    RecordId.ElementFont := efCSS;
    RecordId.ElementPosition := epIgnore;
    RecordId.HeightStyle := ssAuto;
    RecordId.HeightPercent := 100.000000000000000000;
    RecordId.Visible := False;
    RecordId.WidthStyle := ssAuto;
    RecordId.WidthPercent := 100.000000000000000000;
    RecordId.DataField := 'Id';
    AcademyName.SetParentComponent(Self);
    AcademyName.Name := 'AcademyName';
    AcademyName.Left := 40;
    AcademyName.Top := 124;
    AcademyName.Width := 121;
    AcademyName.Height := 22;
    AcademyName.ChildOrder := 3;
    AcademyName.ElementClassName := 'form-control';
    AcademyName.ElementFont := efCSS;
    AcademyName.ElementPosition := epIgnore;
    AcademyName.HeightStyle := ssAuto;
    AcademyName.HeightPercent := 100.000000000000000000;
    AcademyName.MaxLength := 255;
    AcademyName.Text := 'AcademyName';
    AcademyName.WidthStyle := ssAuto;
    AcademyName.WidthPercent := 100.000000000000000000;
    AcademyName.DataField := 'Name';
    AcademyName.DataSource := DataSource;
    Telephone.SetParentComponent(Self);
    Telephone.Name := 'Telephone';
    Telephone.Left := 40;
    Telephone.Top := 236;
    Telephone.Width := 121;
    Telephone.Height := 22;
    Telephone.ChildOrder := 3;
    Telephone.EditType := weNumeric;
    Telephone.ElementClassName := 'form-control';
    Telephone.ElementFont := efCSS;
    Telephone.ElementPosition := epIgnore;
    Telephone.HeightStyle := ssAuto;
    Telephone.HeightPercent := 100.000000000000000000;
    Telephone.MaxLength := 25;
    Telephone.TabOrder := 1;
    Telephone.Text := 'Telephone';
    Telephone.WidthStyle := ssAuto;
    Telephone.WidthPercent := 100.000000000000000000;
    Telephone.DataField := 'Telephone';
    Telephone.DataSource := DataSource;
    Email.SetParentComponent(Self);
    Email.Name := 'Email';
    Email.Left := 40;
    Email.Top := 264;
    Email.Width := 121;
    Email.Height := 22;
    Email.ChildOrder := 3;
    Email.ElementClassName := 'form-control';
    Email.ElementFont := efCSS;
    Email.ElementPosition := epIgnore;
    Email.HeightStyle := ssAuto;
    Email.HeightPercent := 100.000000000000000000;
    Email.MaxLength := 320;
    Email.TabOrder := 2;
    Email.Text := 'Email';
    Email.WidthStyle := ssAuto;
    Email.WidthPercent := 100.000000000000000000;
    Email.DataField := 'Email';
    Email.DataSource := DataSource;
  finally
    RecordId.AfterLoadDFMValues;
    AcademyName.AfterLoadDFMValues;
    Telephone.AfterLoadDFMValues;
    Email.AfterLoadDFMValues;
  end;
end;

end.

